import React from 'react';
import styles from './Phone.scss';
import classNames from 'classnames/bind';

const cx = classNames.bind(styles);

const Phone = ({
  backgroundImage,
  bodyMain,
  bodyTrend,
  bottomScore,
  bottomTrend,
}) => {
  return (
    <div className={cx('Phone')} style={{backgroundImage: `url(${backgroundImage})`}}>
      <div className={cx('Phone__inner')}>
          <div className={cx('Phone__main')}>
            <img className={cx('Phone__img', 'Phone__main-img')} src={bodyMain} alt={''}/>
            <img className={cx('Phone__img', 'Phone__main-img')} src={bodyTrend} alt={''}/>
          </div>
        <img className={cx('Phone__bottom', 'Phone__bottom--odd')} src={bottomScore} alt={''}/>
        <img className={cx('Phone__bottom', 'Phone__bottom--even')} src={bottomTrend} alt={''}/>
      </div>
    </div>
  );
};

export default Phone;


// WEBPACK FOOTER //
// ./src/app/intro/components/Phone/Phone.js